module.exports = __webpack_public_path__ + "static/media/contact-yellow-lines.f8b7497b.svg";